/**
 * Common utilities for use in study-related modals.
 */

/**
 * For use with multi-step modals which only allow submission on the final step.
 * This prevents a "Modal should have at least one submit button" error in cases where all required
 * information has been filled out on the first page (which likely has a 'Next' button rather than 'Submit'),
 * but the intent is that the user must reach the final page of the modal in order to submit.
 */
export function shouldAllowSubmit(
  steps: Array<{
    key: string;
    title: string;
    metadata?: string | undefined;
  }>,
  currentStepKey: string | undefined
): boolean {
  return !(steps.length > 0 && currentStepKey !== steps[steps.length - 1].key);
}
